var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "fas fa-list" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("library_categories")) + "\n\t")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 140 } },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("title"),
                    error: _vm.$v.title.$error
                  },
                  on: { input: _vm.$v.title.$touch },
                  model: {
                    value: _vm.title,
                    callback: function($$v) {
                      _vm.title = $$v
                    },
                    expression: "title"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-6 col-sm-4" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("highlight")))
            ]),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorFeatured,
                options: _vm.featureds
              },
              model: {
                value: _vm.featured,
                callback: function($$v) {
                  _vm.featured = $$v
                },
                expression: "featured"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-6 col-sm-4" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("status")))
            ]),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorStatus,
                options: _vm.statuses
              },
              model: {
                value: _vm.status,
                callback: function($$v) {
                  _vm.status = $$v
                },
                expression: "status"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-6 col-sm-4" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("icon")))
            ]),
            _c("q-btn", {
              attrs: { icon: _vm.selected_icon, color: "tertiary" },
              on: {
                click: function($event) {
                  _vm.show_icons = true
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_library_categories" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": { maxWidth: _vm.getMaxWidth, minHeight: "80vh" }
          },
          model: {
            value: _vm.show_icons,
            callback: function($$v) {
              _vm.show_icons = $$v
            },
            expression: "show_icons"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_icons = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("icon")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-search", {
                    staticClass: "full-width",
                    attrs: { inverted: "", color: "none", debounce: 500 },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                _vm._l(_vm.iconList, function(icon, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "category-icon-item",
                      on: {
                        click: function($event) {
                          return _vm.selectIcon(icon)
                        }
                      }
                    },
                    [_c("q-icon", { attrs: { name: "fas fa-" + icon } })],
                    1
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }